// last_scale = the date of a patient's most recent scaling (ขูดหินปูน) billing,
// computed by the Xano `last_scale` addon and merged onto the patient record
// (patient.scale_date) and each dashboard appointment row (a.scale_date).
//
// "Overdue" = never scaled OR the last scaling was more than ~6 months ago — the
// ขูดหินปูน 6-month recall from SOP-TX-004, and a prime upsell hook. Surfaced as a
// tag in the huddle queue, the patient header, and the appointments page.

const SIX_MONTHS_MS = 183 * 24 * 60 * 60 * 1000

// Pull the scale date (ms) out of whatever shape it arrives in: a patient/appt
// object carrying `scale_date` (merged addon), a `{ scale_date }` object, or a
// raw value (epoch seconds/ms, ISO string, or "YYYY-MM-DD"). Returns null if none.
export function scaleDateMs(src) {
  let v = src
  if (src && typeof src === 'object') {
    v = src.scale_date ?? src.last_scale?.scale_date ?? src.last_scale ?? null
  }
  if (v == null || v === '') return null
  if (typeof v === 'number') return v > 1e11 ? v : v * 1000        // ms vs seconds
  const s = String(v).trim()
  if (/^\d+$/.test(s)) { const n = Number(s); return n > 1e11 ? n : n * 1000 }
  const t = Date.parse(s)
  return Number.isNaN(t) ? null : t
}

/**
 * Scaling status for a patient/appt source.
 * @returns {{ overdue: boolean, never: boolean, ms: number|null }}
 *   never  → no scaling billing on record
 *   overdue→ never, or last scaling > 6 months ago
 */
export function scaleStatus(src, now = Date.now()) {
  const ms = scaleDateMs(src)
  if (ms == null) return { overdue: true, never: true, ms: null }
  return { overdue: now - ms > SIX_MONTHS_MS, never: false, ms }
}

export const isScaleOverdue = (src, now = Date.now()) => scaleStatus(src, now).overdue
